import { get } from 'api';

import {
  LOAD_SEASONS,
  LOADING_METADATA,
  METADATA_FAILED,
  METADATA_LOADED,
  SEASONS_FAILED,
  SEASONS_LOADED,
} from './actionTypes';

export const initialActionsState = {
  loadSeasons: () => {},
  loadMetadata: () => {},
};

export const getActions = (dispatch: {
  (value: { type: any; payload?: any }): void;
  (arg0: { type: string; payload?: any }): void;
}) => ({
  loadSeasons: async (callback) => {
    dispatch({
      type: LOAD_SEASONS,
    });

    const { data, error } = await get(`seed/trading-seasons`);

    if (data && !error) {
      dispatch({
        type: SEASONS_LOADED,
        payload: data,
      });
      callback(data);
    } else {
      dispatch({
        type: SEASONS_FAILED,
        payload: error,
      });
    }
  },

  loadMetadata: async () => {
    dispatch({
      type: LOADING_METADATA,
    });

    const { data, error } = await get('seed/metadata');

    if (data && !error) {
      dispatch({
        type: METADATA_LOADED,
        payload: data,
      });
    } else {
      dispatch({
        type: METADATA_FAILED,
        payload: error,
      });
    }
  },
});
